import type { SetRequiredKeys } from "~/@types/generics"
import type {
  TProductHeader,
  TProductHeaderBundle,
  TProductHeaderProduct,
} from "~/components/ui/Product/ProductHeader/_data/serializer"

export type TProductHeaderWithEmbroidery =
  | SetRequiredKeys<TProductHeaderProduct, "embroidery">
  | SetRequiredKeys<TProductHeaderBundle, "embroidery">

export function isProductHeaderWithEmbroidery(
  productheader: TProductHeader
): productheader is TProductHeaderWithEmbroidery {
  return Boolean(productheader.embroidery)
}
